import React from 'react';
import PropTypes from 'prop-types';
import { Link, graphql, StaticQuery } from 'gatsby';
import PreviewCompatibleImage from './PreviewCompatibleImage';

class EventsRoll extends React.Component {
  render() {
    const { data, featuredEventsOnly } = this.props;
    const { edges: posts } = data.allMarkdownRemark;

    if (featuredEventsOnly) {
      posts = posts.filter((post) => post.frontmatter.featuredevent);
    }

    return (
      <div className="columns is-multiline">
        {posts &&
          posts.map(({ node: post }) => (
            <div className="column is-one-quarter">
              <Link
                className="has-text-primary has-text-weight-bold"
                to={post.fields.slug}
              >
                <div className="card blog-card" key={post.id}>
                  <div className="card-image">
                    <figure className="image">
                      {post.frontmatter.featuredimage ? (
                        <PreviewCompatibleImage
                          imageInfo={{
                            image: post.frontmatter.featuredimage,
                            alt: `featured image thumbnail for post ${post.frontmatter.title}`,
                          }}
                        />
                      ) : null}
                    </figure>
                  </div>
                  <div className="card-content">
                    <div className="content">
                      {post.frontmatter.title}
                      <p>{post.frontmatter.eventdate}</p>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          ))}
      </div>
    );
  }
}

EventsRoll.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
};

export default () => (
  <StaticQuery
    query={graphql`
      query EventsRollQuery {
        allMarkdownRemark(
          sort: { order: DESC, fields: [frontmatter___date] }
          filter: { frontmatter: { templateKey: { eq: "event-post" } } }
        ) {
          edges {
            node {
              excerpt(pruneLength: 400)
              id
              fields {
                slug
              }
              frontmatter {
                title
                templateKey
                publishdate(formatString: "MMMM DD, YYYY")
                eventdate(formatString: "MMMM DD, YYYY")
                featuredevent
                featuredimage {
                  childImageSharp {
                    fluid(maxWidth: 400, quality: 100) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={(data, count) => <EventsRoll data={data} count={count} />}
  />
);
